import {
  ListProfilesRequestSchema,
  ListProfilesResponseSchema,
} from "@redotech/internal-ctx-client";

export const listContextualProfiles = {
  name: "listContextualProfiles" as const,
  input: ListProfilesRequestSchema,
  output: ListProfilesResponseSchema,
};
